import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ProjectsLayout = lazy(() => import('@/pages/projects/layout'));
const ProjectDetailLayout = lazy(() => import('@/pages/projects/detail/layout'));
const ProjectsListPage = lazy(() => import('@/pages/projects'));
const ProjectCreatePage = lazy(() => import('@/pages/projects/create'));
const ProjectViewPage = lazy(() => import('@/pages/projects/detail/view'));
const ProjectUpdatePage = lazy(() => import('@/pages/projects/detail/update'));

/**
 * UG-5264 — project entity routes: the projects grid, create, and a
 * project's view / update pages. `ProjectsLayout` mounts the section
 * breadcrumb; `ProjectDetailLayout` loads the project once for the nested
 * detail pages. Permissions: `@/config/auth/routeAccess`.
 */
export const projectRoutes: RouteConfig = {
  path: '/projects',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: ProjectsLayout,
      children: [
        { path: '', element: ProjectsListPage },
        { path: '/create', element: ProjectCreatePage },
        {
          path: '/:projectId',
          layout: ProjectDetailLayout,
          children: [
            { path: '/view', element: ProjectViewPage },
            { path: '/update', element: ProjectUpdatePage },
          ],
        },
      ],
    },
  ],
};
